import React from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop.jsx";

import HomePage from "./pages/HomePage.jsx";
import PublicWebConnectPage from "./pages/public/PublicWebConnectPage.jsx";

import GuestRoutes from "./route/GuestRoute.jsx";
import HotelRoutes from "./route/HotelRoute.jsx";
import BookerRoutes from "./route/BookerRoute.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Toaster />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/connect/:token" element={<PublicWebConnectPage />} />
        <Route path="/c/:token" element={<PublicWebConnectPage />} />

        {GuestRoutes()}
        {HotelRoutes()}
        {BookerRoutes()}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
